import { formatDate } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AdminService } from 'src/app/Service/admin.service';
import { AuthService } from 'src/app/service/auth.service';
import { CommonService } from 'src/app/service/common.service';
import { ReportService } from 'src/app/service/report.service';
import { GenericValidator } from 'src/app/validation/general-validation';

@Component({
  selector: 'app-loadchart-schedulereport',
  templateUrl: './loadchart-schedulereport.component.html',
})
export class LoadChartScheduleReportComponent implements OnInit {
  CustomerName: string = '';
  MeterName: string = '';
  SiteList: any = [];
  PanelList: any[];
  DeviceList: any[];
  CompanyId: number;
  schedulereportForm: FormGroup;
  EnergyMeterList = [];
  errorMsg: string = '';
  successMsg: string = '';
  displayMessage: { [key: string]: string } = {};
  private genericValidator: GenericValidator;
  private validationMessages: { [key: string]: { [key: string]: string } };
  selectedtimeduration: any = 'Daily';
  selectedreporttiming: any;
  selectedscheduletype: any;
  selecteddayspan: any;
  selectedemailtime: any;
  selectedemailday: any;
  selectedemaildate: any;
  dayspanflag: any = true;
  emailtimeflag: any = true;
  emaildayflag: any = false;
  emaildateflag: any = false;
  ScheduleReportList: any = [];
  dateOptions = Array.from({ length: 30 }, (_, i) => i + 1);
  allCurrentFlag: any;
  SiteId: number;
  PanelId: number;
  MeterId: number;
  DataType: string = '';
  constructor(
    public reportService: ReportService,
    public dialogRef: MatDialogRef<LoadChartScheduleReportComponent>,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: any, private commonservice: CommonService,
  ) {
    this.authService.getValidationMessage().subscribe((resp) => {
      this.validationMessages = resp.schedulereportForm;
      this.genericValidator = new GenericValidator(this.validationMessages);
    });
  }

  ngOnInit(): void {
    this.schedulereportForm = this.formBuilder.group({
      ScheduleType: ['', [Validators.required]],
      DaySpan: [''],
      EmailTime: ['', [Validators.required]],
      EmailDate: [''],
      EmailDay: [''],
      EmailIds: ['', [Validators.required]],
      DataType: ['RawData', [Validators.required]],
      SiteId: ['', [Validators.required]],
      PanelId: ['', [Validators.required]],
      DeviceId: ['', [Validators.required]]
    });

    this.schedulereportForm.valueChanges.subscribe(
      (value) =>
        (this.displayMessage = this.genericValidator.processMessages(
          this.schedulereportForm,
          true
        ))
    );

    this.CompanyId = +localStorage.getItem('CompanyIdForUC');
    this.GetSiteList(this.CompanyId);

    this.GetScheduleReportData();
  }

  Close() {
    this.dialogRef.close();
  }

  DeleteScheduleReportData(i, ScheduleReportId) {
    this.errorMsg = '';
    this.ScheduleReportList.splice(i, 1);

    if (ScheduleReportId > 0) {
      this.errorMsg = '';
      this.successMsg = '';
      this.reportService.DeleteScheduleReportdatabyId(ScheduleReportId).subscribe(
        (result) => {
          this.successMsg = '';
        },
        (error) => {
          this.errorMsg = error;
        }
      );
    }
  }

  formatTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  validateEmailTimingForm() {
    const requiredFields = [
      { key: 'ScheduleType', message: 'Please select Schedule Type !!' },
      { key: 'DaySpan', message: 'Please select Day Span !!' },
      { key: 'EmailDate', message: 'Please select Email Date !!' },
      { key: 'EmailDay', message: 'Please select Email Day !!' },
      { key: 'EmailIds', message: 'Please enter Email Ids !!' },
    ];

    for (const field of requiredFields) {
      if (!this.schedulereportForm.value[field.key]) {
        this.errorMsg = field.message;
        return false;
      }
    }
    return true;
  }

  calculateNextSchedule(
    emailTime: string,
    scheduleType: string,
    daySpan: number,
    selectedEmailDay?: string,
    selectedEmailDate?: number
  ): string {
    const currentDate = new Date();

    const dateString = emailTime;
    const dateObj = new Date(dateString);

    if (!isNaN(dateObj.getTime())) {
      const hours = dateObj.getHours().toString().padStart(2, '0');
      const minutes = dateObj.getMinutes().toString().padStart(2, '0');
      const timeOnly = `${hours}:${minutes}`;
      emailTime = timeOnly;
    }

    // Split the EmailTime to get hours and minutes
    const [hours, minutes] = emailTime.split(':').map(Number);

    // Set the hours and minutes for the current date
    currentDate.setHours(hours, minutes, 0, 0);

    if (scheduleType === 'Daily') {
      // Daily: Add daySpan (usually 1 for next day)
      currentDate.setDate(currentDate.getDate() + daySpan);
    } else if (scheduleType === 'Weekly' && selectedEmailDay) {
      // Weekly: Find the upcoming selected day of the week
      const daysOfWeek = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
      ];
      const selectedDayIndex = daysOfWeek.indexOf(selectedEmailDay);
      if (selectedDayIndex !== -1) {
        const todayIndex = currentDate.getDay();
        let daysToAdd = (selectedDayIndex + 7 - todayIndex) % 7;

        // If today is the same day as the selected day, move to next week's day
        if (daysToAdd === 0) {
          daysToAdd = 7; // Skip to the next occurrence of the same day
        }

        currentDate.setDate(currentDate.getDate() + daysToAdd + daySpan); // Add daySpan if needed
      }
    } else if (scheduleType === 'Monthly' && selectedEmailDate) {
      // Monthly: Handle next occurrence of the selected date
      const today = currentDate.getDate();
      if (selectedEmailDate === today) {
        // If today is the same as the selected date, move to the next month
        currentDate.setMonth(currentDate.getMonth() + 1);
        currentDate.setDate(selectedEmailDate);
      } else if (selectedEmailDate > today) {
        // If the selected date is later this month
        currentDate.setDate(selectedEmailDate);
      } else {
        // If the selected date has already passed, move to next month
        currentDate.setMonth(currentDate.getMonth() + 1);
        currentDate.setDate(selectedEmailDate);
      }
    }

    // Return the formatted date string in 'YYYY-MM-DDTHH:MM:SS' format
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const hoursLocal = String(currentDate.getHours()).padStart(2, '0');
    const minutesLocal = String(currentDate.getMinutes()).padStart(2, '0');
    const secondsLocal = String(currentDate.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day}T${hoursLocal}:${minutesLocal}:${secondsLocal}`;
  }

  AddScheduleReportData() {
    this.successMsg = '';
    this.errorMsg = '';
    if (this.schedulereportForm.invalid) {
      this.displayMessage = this.genericValidator.processMessages(
        this.schedulereportForm,
        true,
        this.validationMessages
      );
      return;
    }

    var existscount = this.ScheduleReportList.filter(
      (a) =>
        a.ScheduleType == this.selectedscheduletype.value &&
        a.MeterId == this.MeterId &&
        a.EmailTime == this.schedulereportForm.value.EmailTime &&
        a.EmailIds == this.schedulereportForm.value.EmailIds
    ).length;

    if (existscount > 0) {
      this.errorMsg = 'Same Schedule Type exist with same Meter and Time!!';
      return;
    } else {
      const dateString = this.schedulereportForm.value.EmailTime;
      const dateObj = new Date(dateString);

      if (!isNaN(dateObj.getTime())) {
        const hours = dateObj.getHours().toString().padStart(2, '0');
        const minutes = dateObj.getMinutes().toString().padStart(2, '0');
        const timeOnly = `${hours}:${minutes}`;
        // "09:15:00"
        this.schedulereportForm.value.EmailTime = timeOnly;
      }

      let newobj = {
        ScheduleReportId: 0,
        SiteId: this.SiteId,
        PanelId: this.PanelId,
        MeterId: this.MeterId,
        MeterName: this.MeterName,
        CustomerName: this.CustomerName,
        ScheduleType: this.selectedscheduletype.value,
        EmailDate:
          this.selectedscheduletype.value === 'Monthly'
            ? this.schedulereportForm.value.EmailDate || ' '
            : ' ',
        EmailDay:
          this.selectedscheduletype.value === 'Weekly'
            ? this.selectedemailday
              ? this.selectedemailday.value
              : ' '
            : ' ',
        EmailTime: this.schedulereportForm.value.EmailTime,
        EmailIds: this.schedulereportForm.value.EmailIds,
        NextSchedule: this.calculateNextSchedule(
          this.schedulereportForm.value.EmailTime,
          this.selectedscheduletype.value, // ScheduleType (Daily, Weekly, Monthly)
          this.selectedscheduletype.value === 'Daily' ? 1 : 0, // For Daily add 1 day
          this.selectedscheduletype.value === 'Weekly'
            ? this.selectedemailday.value
            : undefined, // For Weekly pass the selected email day
          this.selectedscheduletype.value === 'Monthly'
            ? parseInt(this.schedulereportForm.value.EmailDate)
            : undefined // For Monthly pass the selected email date
        ),
        PreviousSchedule: this.calculateNextSchedule(
          this.schedulereportForm.value.EmailTime,
          this.selectedscheduletype.value,
          0, // For PreviousSchedule use today
          undefined,
          undefined
        ),
        DaySpan:
          this.selectedscheduletype.value === 'Daily'
            ? this.selecteddayspan
              ? parseInt(this.selecteddayspan.value)
              : 0
            : 0,
        CompanyId: this.CompanyId,
      };

      this.ScheduleReportList.push(newobj);
    }
  }

  SaveScheduleReportData() {
    this.successMsg = '';
    this.errorMsg = '';
    
    var newobj = {
      listScheduleReport: this.ScheduleReportList,
      CompanyId: this.CompanyId,
    };
    this.errorMsg = '';
    this.successMsg = '';
    this.reportService.TransScheduleReportData(newobj).subscribe(
      (result) => {
        this.successMsg = 'Data saved successfully';
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  timeChangeHandler(event) {
    const date = formatDate(event, 'HH:mm', 'en');
    this.schedulereportForm.patchValue({
      EmailTime: date,
    });
  }

  OnChangeScheduleType(e: any) {
    if (e.value === 'Weekly') {
      this.emaildayflag = true;
      this.emaildateflag = false;
      this.dayspanflag = false;
    } else if (e.value == 'Daily') {
      this.emaildayflag = false;
      this.emaildateflag = false;
      this.dayspanflag = true;
    } else if (e.value == 'Monthly') {
      this.emaildayflag = false;
      this.emaildateflag = true;
      this.dayspanflag = false;
    }
    this.selectedscheduletype = e;
  }

  OnChangeDaySpan(e: any) {
    this.selecteddayspan = e;
  }

  OnChangeEmailTime(e: any) {
    this.selectedemailtime = e;
  }

  OnChangeEmailDay(e: any) {
    this.selectedemailday = e;
  }

  OnChangeEmailDate(e: any) {
    this.selectedemaildate = e;
  }

  GetScheduleReportData() {
    this.errorMsg = '';
    this.successMsg = '';
    this.reportService.GetScheduleReportData(this.CompanyId).subscribe(
      (result) => {
        this.ScheduleReportList = result;
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  // Get Site List
  GetSiteList(CompanyId) {
    this.commonservice.GetSiteList(CompanyId).subscribe(
      (result) => {
        this.SiteList = result;
      },
      (error) => {
        this.errorMsg = error
      }
    )
  }

    // Called on change Site
    OnChangeSite(event) {

      this.SiteId = event?.value;    

      this.schedulereportForm.patchValue({
        SiteId: this.SiteId
      });
  

    // Lookup full object using SiteList
    const selectedSite = this.SiteList.find(site => site.CodeValue === this.SiteId);

    this.CustomerName = selectedSite?.CodeDisplayText ?? '';
      this.GetPanelList(event?.value);
      this.schedulereportForm.patchValue({
        PanelId: '',
        DeviceId: ''
      });
      this.DeviceList = []
    }

    // Get Panel List
  GetPanelList(SiteId) {
    this.commonservice.GetPanelList(SiteId).subscribe(
      (result) => {
        this.PanelList = result;
      },
      (error) => {
        this.errorMsg = error
      }
    )
  }

  // Called on change Panel
  OnChangePanel(event) {
    this.schedulereportForm.patchValue({
      PanelId: event.value
    });

    this.PanelId = event.value;
    if (event.value == '') {
      this.DeviceList = []
    }
    this.GetEnergymeterList(this.SiteId, this.PanelId);

    this.schedulereportForm.patchValue({
      DeviceId: ''
    });
  }

  // Get Energy meter List
  GetEnergymeterList(SiteId, PanelId) {
    this.commonservice.GetEnergyMeterIdList(SiteId, PanelId, 'Y').subscribe(
      (result) => {
        this.DeviceList = result;
      },
      (error) => {
        this.errorMsg = error
      }
    )
  }

  // Called on change Device
  OnChangeDeviceId(event) {

    this.MeterId = event?.value;

    this.schedulereportForm.patchValue({
      DeviceId: event?.value,
    });

    // Lookup full object using SiteList
    const selecteddevice = this.DeviceList.find(device => device.CodeValue === this.MeterId);

    this.MeterName = selecteddevice?.CodeDisplayText ?? '';    
  }

  // Called on change Device
  OnChangeDataType(event) {
    this.schedulereportForm.patchValue({
      DataType: event.value
    });
  }
}
